<app-double-section-page-template [narrower]="true" [contentAlignment]="'center'">
  <ng-container intro-content>
    <h2 [innerHTML]="titleType() | translate" double-section-page-template-title></h2>
  </ng-container>
  <ng-container payload-content>
    <img src="/assets/img/shapes/shape-{{ iconType() }}.svg" alt="{{ iconType() }}" double-section-page-template-icon />
    <p class="display-h3 mb-6">{{ iconLabelType() | translate }}</p>
    <p [innerHTML]="descriptionType() | translate : { email: email }"></p>
    <form class="max-w-[385px] mb-4">
      <fieldset>
        <label
          class="text-[14px] font-bold text-cm-blue-900 dark:text-app-dark-mode-white w-full flex mb-[14px] items-center"
        >
          {{ labelType() | translate }}
        </label>
        <app-otp-input #otpInputComponent (otpCompleted)="onCodeCompleted($event)"></app-otp-input>
        <app-action-button
          [facet]="'primary'"
          [disabled]="!codeInputState.isComplete"
          [isFullWidth]="true"
          (action)="submitCode()"
          label="shared.common.verify"
          [waiting]="waiting"
          progressLabel="shared.common.verifying"
        >
        </app-action-button>
      </fieldset>
    </form>
    <app-link-pair
      *ngIf="isGoogleAuth()"
      label="{{ 'login.2fa.disable.link-label' | translate }}"
      routerLink="/disable-2fa"
      addressLabel="{{ 'login.2fa.disable.link-text' | translate }}"
      addressIcon="/assets/img/arrow-right-blue.svg"
      [openInNewWindow]="false"
    ></app-link-pair>
  </ng-container>
</app-double-section-page-template>
